const termsItems = document.querySelectorAll('.terms-accordion__item');

termsItems.forEach(item => {
  const button = item.querySelector('.terms-accordion__question');
  const answerWrapper = item.querySelector('.terms-accordion__answer-wrapper');
  const answer = item.querySelector('.terms-accordion__answer');

  if (item.classList.contains('is-open')) {
    answerWrapper.style.height = answer.offsetHeight + 'px';
  }

  button.addEventListener('click', function() {
    const isOpen = item.classList.contains('is-open');

    if (isOpen) {
      answerWrapper.style.height = answer.offsetHeight + 'px';
      requestAnimationFrame(() => {
        answerWrapper.style.height = '0px';
      });
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
    } else {
      const targetHeight = answer.offsetHeight;
      answerWrapper.style.height = '0px';
      requestAnimationFrame(() => {
        answerWrapper.style.height = targetHeight + 'px';
      });
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    }
  });

  answerWrapper.addEventListener('transitionend', function() {
    if (item.classList.contains('is-open')) {
      answerWrapper.style.height = 'auto';
    }
  });
});
